import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class SearchBarService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getTitle = (): string => 'Search bars';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'search-bars/0', 'title': 'Search List', 'theme': 'layout1' },
      { 'url': 'search-bars/1', 'title': 'Field + header', 'theme': 'layout2' },
      { 'url': 'search-bars/2', 'title': 'Field + header 2', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): Array<any> => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'toolbarTitle': 'Search List',
      'items': [
        {
          'id': 1,
          'title': 'Sara J. Rogers',
          'subTitle': 'sara@.com',
          'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
          'image': 'assets/imgs/avatar/17.jpg',
          'imageAlt': 'avatar',
          'button': 'Follow',
        },
        {
          'id': 2,
          'title': 'Dana Robinson',
          'subTitle': 'robinson@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/18.jpg',
          'imageAlt': 'avatar',
          'button': 'Follow',
        },
        {
          'id': 3,
          'title': 'Dennis K. Godina',
          'subTitle': 'dodina@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/19.jpg',
          'imageAlt': 'avatar',
          'button': 'Follow',
        },
        {
          'id': 4,
          'title': 'Robert  Willer',
          'subTitle': 'willer@.com',
          'description': 'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteratione',
          'image': 'assets/imgs/avatar/20.jpg',
          'imageAlt': 'avatar',
          'button': 'Follow',
        },
        {
          'id': 5,
          'title': 'Boring Dreams',
          'subTitle': 'boring@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/21.jpg',
          'imageAlt': 'avatar',
          'button': 'Follow',
        },
        {
          'id': 6,
          'title': 'Elizabeth B. Custer',
          'subTitle': 'custer@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/22.jpg',
          'imageAlt': 'avatar',
          'button': 'Follow',
        },
        {
          'id': 7,
          'title': 'Jean S. Beaty',
          'subTitle': 'jean@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/23.jpg',
          'imageAlt': 'avatar',
          'button': 'Follow',
        },
        {
          'id': 8,
          'title': 'Sara Black',
          'subTitle': 'black@.us',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/24.jpg',
          'imageAlt': 'avatar',
          'button': 'Follow',
        },
        {
          'id': 9,
          'title': 'Justin Cain',
          'subTitle': 'cain@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/19.jpg',
          'imageAlt': 'avatar',
          'button': 'Follow',
        },
        {
          'id': 10,
          'title': 'Kenneth Jones',
          'subTitle': 'jones@.com',
          'description': 'When an unknown printer took a galley of type and scrambled it to make',
          'image': 'assets/imgs/avatar/20.jpg',
          'imageAlt': 'avatar',
          'button': 'Follow',
        }
      ]
    };
  }

  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'toolbarTitle': 'Field + header',
      'headerImage': 'assets/imgs/background/10.jpg',
      'items': [
        {
          'id': 1,
          'title': 'Mongoose Dolomite Fat Tire Mountain Bike',
          'price': '$ 20 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/8.jpg',
          'shareIcon': 'share'
        },
        {
          'id': 2,
          'title': 'Xspec 26" 21-Speed Folding Mountain Bike',
          'price': '$ 700 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/9.jpg',
          'shareIcon': 'share'
        },
        {
          'id': 3,
          'title': 'Sixthreezero Around The Block Men’s Beach Cruiser Bicycle',
          'price': '$ 300 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/10.jpg',
          'shareIcon': 'share'
        },
        {
          'title': 'Schwinn Huron and Mikko Adult Beach Cruiser Bike',
          'price': '$ 500 per month',
          'available': 'Available Now',
          'image': 'assets/imgs/background/11.jpg',
          'shareIcon': 'share'
        },
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'toolbarTitle': 'Field + header 2',
      'headerImage': 'assets/imgs/background/5.jpg',
      'items': [
        {
          'id': 1,
          'title': 'Porsche Taycan Turbo',
          'subtitle': 'LONDON, UNITED KINGDOM',
          'image': 'assets/imgs/background/6.jpg',
          'oldPrice': '$42.99',
          'category': 'Best Sports Convertibles',
          'newPrice': '$35.99'
        },
        {
          'id': 2,
          'title': 'Volkswagen Golf GTI',
          'subtitle': 'GSTAAD, SWITZERLAND',
          'image': 'assets/imgs/background/4.jpg',
          'oldPrice': '$42.99',
          'category': 'Best Hot Hatches',
          'newPrice': '$35.99'
        },
        {
          'id': 3,
          'title': 'BMW M8 Convertible',
          'subtitle': 'SANTA BARBARA, CALIFORNIA',
          'image': 'assets/imgs/background/7.jpg',
          'oldPrice': '$42.99',
          'category': 'Best Sport Sedans',
          'newPrice': '$35.99'
        },
        {
          'id': 4,
          'title': 'Hyundai Veloster N',
          'subtitle': 'PEBBLE BEACH, CALIFORNIA',
          'image': 'assets/imgs/background/1.jpg',
          'oldPrice': '$42.99',
          'category': 'Best Supercars',
          'newPrice': '$35.99'
        },
        {
          'id': 5,
          'title': 'Mercedes-AMG CLA 45',
          'subtitle': 'MACAU, CHINA',
          'image': 'assets/imgs/background/2.jpg',
          'oldPrice': '$42.99',
          'category': 'Best Sports Coupes',
          'newPrice': '$35.99'
        },
        {
          'id': 6,
          'title': 'Ford Mustang Bullitt',
          'subtitle': 'MALIBU, CALIFORNIA',
          'image': 'assets/imgs/background/3.jpg',
          'oldPrice': '$42.99',
          'category': 'Best Sports Coupes',
          'newPrice': '$35.99'
        }
      ]
    };
  }

  load(item: any): Observable<any> {
    this.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('searchBars/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            this.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            this.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        this.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
